const WP_Component = wp.element.Component;

import classNames from 'classnames';

/**
 * Class Block
 */
export default class Block extends WP_Component {
  static attributes() {
    return {};
  }

  static getAttributes() {
    let attributes = this.attributes();

    for (let attribute_id in attributes) {
      if (attributes[attribute_id].getAttributes) {
        attributes[attribute_id] = attributes[attribute_id].getAttributes(
          attribute_id
        );
      }
    }

    return attributes;
  }

  constructor() {
    super(...arguments);

    this.state = {
      name: this.props.name,
      attributes: this.props.attributes,
      isView: this.isView.bind(this),
      setAttr: this.setAttr.bind(this),
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (state.attributes != props.attributes) {
      return { attributes: props.attributes };
    }

    return null;
  }

  attr(key) {
    if (this.props.attributes && typeof this.props.attributes[key] != 'undefined')
      return this.props.attributes[key];

    return null;
  }

  setAttr(attributes) {
    this.props.setAttributes(attributes);
    this.setState(() => ({ attributes: attributes }));
  }

  isView() {
    return typeof this.props.setAttributes == 'undefined';
  }

  render() {
    return null;
  }

  className(classes) {
    return classNames(classes, this.props.className, this.props.attributes.className);
  }
}
